import { Component, Input, OnInit, ElementRef, ViewChild, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { NoiseDropLineParam, NoiseDropToolboxData } from './noise-dropbox-line-interface';
import { ECharts } from 'echarts'
import { fromEvent } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { CommonService } from "../../service/common.service";
import { NoiseDropboxLineService } from './noise-dropbox-line.service';
import * as _ from 'lodash'


@Component({
  selector: 'bcac-noise-dropbox-line',
  templateUrl: './noise-dropbox-line.component.html',
  styleUrls: ['./noise-dropbox-line.component.scss']
})
export class NoiseDropboxLineComponent implements OnInit {

  constructor(
    private noiseDropLineService: NoiseDropboxLineService,
    private commonService: CommonService,
  ) {

  }


  @Output() bcacGetChartInstance: EventEmitter<ECharts> = new EventEmitter<ECharts>();
  @Output() bcacBrushCalculation: EventEmitter<any> = new EventEmitter<any>()

  //todo toolbox事件
  @Output() bcacBrushSelected: EventEmitter<any> = new EventEmitter<any>()
  @Output() bcacBrushEnlarge: EventEmitter<any> = new EventEmitter<any>()
  @Output() bcacBrushRestore: EventEmitter<any> = new EventEmitter<any>()
  @Output() bcacChartMultipleChoiceChecked: EventEmitter<any> = new EventEmitter<any>()
  @Output() bcacChartSingleChoiceChecked: EventEmitter<any> = new EventEmitter<any>()

  Option: any = this.noiseDropLineService.getDefaultOpitonsOfNoiseDropLineChart()

  public _bcacChartTitle: { show: boolean, label: string } = {
    show: true,
    label: "声学分析"
  };



  //todo 是否显示标题
  @Input()
  set bcacChartShowTitle(show: boolean) {
    this._bcacChartTitle.show = typeof (show) == "string"
      ? JSON.parse(show)
      : show;
  }
  //todo 标题文字
  @Input()
  set bcacChartTitleText(text: string) {
    this._bcacChartTitle.label = text;
  }

  // todo 下载文件名
  public _bcacChartFileName = "图表";
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }


  //todo 图数据
  receiveChartData  //接收的chart数据
  public _bcacChartDefaultValueData
  public _bcacNoiseDropToolboxData
  @Input()
  set bcacChartData(data: NoiseDropLineParam) {
    if (data) {
      this.receiveChartData = data

      const funcObj = {
        bcacBrushEnlarge: this.bcacBrushEnlarge,
        bcacBrushRestore: this.bcacBrushRestore,
        bcacBrushCalculation: this.bcacBrushCalculation,
      }

      this.Option = this.noiseDropLineService.changeChartData(this.Option, data)
      
      if (data.toolboxDatas) {
        if (data.toolboxDatas.singleChoiceData){
          for (const item of data.toolboxDatas.singleChoiceData){
            if (item.ischecked){
              this.showSingleChoiceata = item.value
            } 
          }
        }
        if (data.toolboxDatas.multipleChoiceData) {
          for (const item of data.toolboxDatas.multipleChoiceData) {
            if (item.ischecked) {
              this.showMultipleDataList.push(item.value)
            }
          }
        }
        this._bcacNoiseDropToolboxData = data.toolboxDatas
        this.Option = this.noiseDropLineService.changeToolboxItem(this.Option, this._bcacNoiseDropToolboxData, funcObj)
      } else {
        this.showSingleChoiceata = null
        this.showMultipleDataList = []
        this.Option = this.noiseDropLineService.changeToolboxItem(this.Option, [], funcObj)
      }
    }
  }


  //todo tooltip显示格式化
  @Input()
  set bcacTooltipFormatter(value: any) {
    this.Option.tooltip = this.noiseDropLineService.setTooltipFormat(value);
  }

  //todo 是否显示toolbox
  _isShowToolbox
  @Input()
  set bcacChartShowToolbox(show: boolean | string) {
    this._isShowToolbox = typeof (show) == "string"
      ? JSON.parse(show)
      : show;
    this.Option.toolbox.show = this._isShowToolbox
  }


  //todo loading状态
  public _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }


  // //todo x轴名称
  // @Input()
  // set bcacXAxisName(bcacXaxisName: string) {
  //   this.Option.xAxis[0].name = bcacXaxisName
  // }

  //todo y轴名称
  _bcacYAxisName
  @Input()
  set bcacYAxisName(bcacYaxisName: string) {
    this.Option.yAxis[0].name = bcacYaxisName
    this._bcacYAxisName = bcacYaxisName
  }
  
  //todo  y轴名称距离
  @Input()
  set bcacYAxisNameGap(yAxisNameGap: number | string) {
    this.Option.yAxis[0].nameGap = Number(yAxisNameGap)
  }

  //todo x轴刻度标签旋转
  @Input()
  set bcacXAxisLabelRotate(xAxisLabelRotate: number) {
    this.Option.xAxis[0].axisLabel.rotate = xAxisLabelRotate;
  }
  //todo  y轴刻度标签旋转
  @Input()
  set bcacYAxisLabelRotate(yAxisLabelRotate: number) {
    this.Option.yAxis[0].axisLabel.rotate = yAxisLabelRotate;
  }



  //todo 框选事件
  brushSelected($event) {
    this.bcacBrushSelected.emit($event)
  }

  ngOnInit() {
    this.renderGraph()
    fromEvent(window, "resize")
      .pipe(debounceTime(200))
      .subscribe(() => {
        let style = this.commonService.setNoiseDropboxLine();
        if (this.echartInstance) {
          this.echartInstance.setOption({
            toolbox: {
              itemSize: style.toolbox.itemSize,
              itemGap: style.toolbox.itemGap,
            },
            grid: style.grid,
            legend: {
              itemSize: style.legend.itemSize,
              itemGap: style.legend.itemGap
            },
          });
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateOption()
  }

  updateOption() {
    if (this.echartInstance) {
      let option = this.Option
      
      this.echartInstance.setOption(option, true);

    }
  }

  //todo 渲染图
  chartOption;//图option
  renderGraph() {
    this.chartOption = this.Option
  }

  //todo 获取实例
  echartInstance;
  onOptionInit(ec) {
    this.echartInstance = ec;
    this.bcacGetChartInstance.emit(ec)
  }



  //todo toolbox间隔改变
  bcacToolboxIntervalChange(e) {
    if (this.echartInstance) {
      let option = this.echartInstance.getOption()
      option.xAxis[0].axisLabel.interval = Number(e)
      this.echartInstance.setOption(option, true)
    }
  }

  //todo 测量值改变
  showSingleChoiceata: string
  bcacToolboxSingleChoiceChange(e) {
    
    this.showSingleChoiceata = e.value
    if (this.echartInstance) {
      let option = this.echartInstance.getOption()    
      let newdata = []
      for (const item of this.receiveChartData.seriesDatas) { 
        if (e.value == item.property && (this.showMultipleDataList.length ? this.showMultipleDataList.includes(item.nameId) : true)) {
          if (e.value == 'custom'){
            newdata.push({
              name: item.name,
              value: item.nameId,
              type: 'custom',
              renderItem: item.customRender,
              smooth: true,
              "z": 10,
              data: item.data,
            })
          }else{
            newdata.push({
              name: item.name,
              value: item.nameId,
              type: 'line',
              symbol: 'circle',//实心
              smooth: true,
              data: item.data,
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 1//设置线条粗细
                  }
                }
              }
            })
          }      
        }
      }
      option.series = newdata
      
      option.yAxis[0].name = e.yAxisName ? e.yAxisName : this._bcacYAxisName
      
      this.echartInstance.setOption(option, true)
    } 
    this.bcacChartSingleChoiceChecked.emit(e.value)
  }

  //todo 显示示例改变
  showMultipleDataList = []
  bcacToolboxMultipleChoiceChange(e) {
    this.showMultipleDataList = e
    if (this.echartInstance) {
      let option = this.echartInstance.getOption()
      let newdata = []
      for (const item of this.receiveChartData.seriesDatas) {      
        if (e.includes(item.nameId) && (this.showSingleChoiceata ? this.showSingleChoiceata == item.property : true)) {
          if (item.property == 'custom') {
            newdata.push({
              name: item.name,
              value: item.nameId,
              type: 'custom',
              renderItem: item.customRender,
              smooth: true,
              "z": 10,
              data: item.data,
            })
          }else{
            newdata.push({
              name: item.name,
              value: item.nameId,
              type: 'line',
              symbol: 'circle',//实心
              smooth: true,
              data: item.data,
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 1//设置线条粗细
                  }
                }
              }
            })
          }
         
        }
      }
      option.series = newdata
      this.echartInstance.setOption(option, true)
    }
    this.bcacChartMultipleChoiceChecked.emit(e)
  }





}
